

















import { listFactory } from '@/main/pages';
import { NAME, addOneMonth, subtractOneDay } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';
import { showAlert } from '@/main/utils/notifications';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields, getCurrentLanguageId } from '@/main/utils/commonFunctions';

    export default listFactory(NAME, store).extend({

    data() {
		return {
			parameters: 'null' as string,
			fromDate: 'GrnOpenDate',
			toDate: 'GrnClosedDate',
		};
	},

    computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.OrganizationIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.OrganizationIds);
		},
	},

    methods: {
            async exportFun() {
                try {
				if (this.filter.OrganizationIds == null || this.filter.OrganizationIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
				this.startLoading();
                const urlParameters: string = this.GetParameters(this.OrganizationIds, this.GrnOpenDate, this.GrnClosedDate);
                if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
                    await apiProvider.GetItemsReceivedDetailReport(urlParameters,getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId), columnsSeq);
                }
                }
                catch (error) {
				showAlert({
					message: this.LocalizeChyboveHlasky('LocalMsg'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
			} finally {
				this.endLoading();
			}
            },

            GetParameters(OrganizationIds : any, GrnOpenDate : any, GrnClosedDate : any) {
			this.parameters = '';
			this.parameters = this.parameters.concat(`GrnOpenDate=${new Date(GrnOpenDate!).toISOString()}&GrnClosedDate=${new Date(GrnClosedDate).toISOString()}`);
			if (OrganizationIds.length > 0) {
				OrganizationIds.forEach((OrganizationIds: any) => {
					this.parameters = this.parameters.concat(`&OrganizationIds=${OrganizationIds}`);
				});
			}
			return this.parameters;
		},

            dateValidation() {
                if (this.GrnOpenDate && this.GrnClosedDate) {
                    const checkDateRange = new Date(this.GrnOpenDate.getFullYear(), this.GrnOpenDate.getMonth() + addOneMonth, this.GrnOpenDate.getDate() - subtractOneDay);
                    if (this.GrnClosedDate > checkDateRange) {
                        this.showErrorAlert({ message: this.LocalizePopisPoli('VALIDATION_FOR_ONE_MONTH') });
                        this.GrnOpenDate = null;
                        this.GrnClosedDate = null;
                        return false;
                    }
                }
            },            
            async filterClick() {
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.OrganizationIds,
				(columnsSeq) => ({
					OrganizationIds: this.OrganizationIds,
					GrnOpenDate: this.GrnOpenDate,
					GrnClosedDate: this.GrnClosedDate,
					ColumnSequence: columnsSeq.join(','),
                    LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},

           
        },
    });
